module.exports = new __parcel__URL__("step_two_vector_light_optimal.f3cf8e53.png").toString();